/**
 * Domain Redirect Component
 * Automatically redirects users from old domain to new domain
 * Add this at the root of your app (in App.tsx or main router)
 */

import { useEffect } from 'react';
import { checkAndRedirectDomain } from '@/utils/domain-redirect';

export function DomainRedirect() {
  useEffect(() => {
    checkAndRedirectDomain();
  }, []);

  // This component renders nothing - it just handles the redirect
  return null;
}
